import type { ReactNode } from "react";

interface PageHeaderProps {
  overline?: string;
  title: string;
  hint?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ overline, title, hint, actions }: PageHeaderProps) {
  return (
    <header className="mb-6 flex items-baseline justify-between gap-4 flex-wrap">
      <div>
        {overline && (
          <p className="text-xs tracking-widest text-[color:var(--color-alto-muted)] uppercase">
            {overline}
          </p>
        )}
        <h1 className="font-[family-name:var(--font-display)] text-3xl mt-1">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-3">
        {hint && <span className="text-sm text-[color:var(--color-alto-muted)]">{hint}</span>}
        {actions}
      </div>
    </header>
  );
}
